$.fn.Vh = function() {
  let self = this

  self.update = function() {
    self.css('--vh', document.documentElement.clientHeight + 'px');
  }

  return function() {
    $(window).on('load orientationchange resize', self.update)
    return self
  }()
}

export default {
  init() {
    $('.app').each(function() {
      $(this).Vh()
    })
  },
}
